module.exports = __webpack_public_path__ + "static/img/zijian.f2dfabaa.png";